import React from 'react';
import PropTypes from 'prop-types';
import './button-group.scss';
import clsx from 'clsx';
import { IconSizes } from '../icon';
import { NEXT_BUTTON_ID, PREV_BUTTON_ID } from '../paginator/constants';

const ButtonGroup = ({
  items, className, onClick,
}) => {
  const classNames = clsx('btn-grp-cont', className);

  const handleButtonClick = (id) => {
    if (onClick && typeof onClick === 'function') {
      onClick.call(null, id);
    }
  };

  const getItemView = ({
    id, label, disabled, selected, renderRightIcon, renderLeftIcon,
  }, index) => (
    <button
      type="button"
      key={String(index)}
      onClick={() => { if (!disabled) handleButtonClick(id); }}
      className={clsx('btn-grp-item', { selected, disabled, nav: id === PREV_BUTTON_ID || id === NEXT_BUTTON_ID })}
    >
      {renderLeftIcon ? <span className="bg-icon-left">{renderLeftIcon({ size: IconSizes.MEDIUM })}</span> : null}
      {label}
      {renderRightIcon ? <span className="bg-icon-right">{renderRightIcon({ size: IconSizes.MEDIUM })}</span> : null}
    </button>
  );

  return (
    <div className={classNames}>
      {items.map((item, index) => getItemView(item, index))}
    </div>
  );
};

ButtonGroup.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    disabled: PropTypes.bool,
    selected: PropTypes.bool,
    renderLeftIcon: PropTypes.func,
    renderRightIcon: PropTypes.func,
  })),
  className: PropTypes.string,
  onClick: PropTypes.func,
};

ButtonGroup.defaultProps = {
  items: [],
  className: '',
  onClick: () => {},
};

export {
  ButtonGroup as default,
};
